import { SetMenu } from '@config/menu.config';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AppConfig } from '@config/app.config';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivate {
  public menu: any;

  constructor(public appConfig: AppConfig, private router: Router) {
    this.menu = new SetMenu();
  }

  canActivate(activatedRoute: ActivatedRouteSnapshot) {
    const path = activatedRoute.routeConfig.path;
    const validate = this.menu.menu.find((element: any) => {
      if (element.show) {
        if (element.type === this.appConfig.TYPE_SINGLE) {
          return element.link === path;
        } else {
          return element.child.find((child: any) => {
            if (child.link === path && child.show) {
              return child.link === path;
            }
          });
        }
      }
    });

    if (validate !== undefined) {
      return true;
    }

    this.router.navigate(['']);
  }
}
